import FinancialEntityRelinkWarning from '@/components/financialEntities/FinancialEntityRelinkWarning';
import { useMyDisconnectedFundingAccountsForGoalAccount } from '@/components/goals/helpers';
import { Box } from '@chakra-ui/react';
import { getActionableGoalAccountForCurrentUser } from '../detail/helpers';
import { useGoalDetailContext } from './GoalDetailContext';

export default function GoalDetailDisconnectedAccounts() {
    const { goal } = useGoalDetailContext();
    const account = goal && getActionableGoalAccountForCurrentUser(goal);
    const disconnectedAccounts =
        useMyDisconnectedFundingAccountsForGoalAccount(account);

    return (
        <Box>
            {disconnectedAccounts.map((account) => (
                <FinancialEntityRelinkWarning
                    key={account.id}
                    account={account}
                    includeFinancialEntityWithMask={true}
                    mx={6}
                    mt={6}
                />
            ))}
        </Box>
    );
}
